// AI-prompt button
//
// On click, evoke a text input element (another row/column above text input?)
// Prompt includes any input we've already provided
// Prompt output replaces recipe text content
import { Button } from "react-bootstrap";
import { Stars } from "react-bootstrap-icons";
const AIButton = () => {
  return (
    <Button variant="outline-info">
      <Stars />
    </Button>
  );
};

export default AIButton;
